/**
 * @file PageTitleWrapper.tsx
 * @module _admin/layout/components/toolbar/page-title/PageTitleWrapper
 * @description Renders the PageTitleWrapper component that provides route titles and breadcrumb context in the toolbar.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.3.0
 */

import { useLayout } from "../../../core";
import { PageTitle } from "./PageTitle";

const PageTitleWrapper = () => {
  const { config } = useLayout();
  if (!config.app?.pageTitle?.display) {
    return null;
  }

  return <PageTitle />;
};

export { PageTitleWrapper };
